"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DiscountData = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var DiscountData = {
  theme: _propTypes.default.string,
  id: _propTypes.default.number,
  name: _propTypes.default.string,
  amount: _propTypes.default.number,
  description: _propTypes.default.string,
  validity: _propTypes.default.objectOf(_propTypes.default.shape({
    startDate: _propTypes.default.instanceOf(Date),
    endDate: _propTypes.default.instanceOf(Date)
  })),
  stackable: _propTypes.default.bool,
  bigPointsAllowed: _propTypes.default.bool,
  minSpend: _propTypes.default.number,
  discountValidity: _propTypes.default.string,
  translations: _propTypes.default.objectOf(_propTypes.default.shape({
    tnc: _propTypes.default.string,
    discountDesc: _propTypes.default.string,
    validUntil: _propTypes.default.string,
    minSpendDesc: _propTypes.default.string
  })),
  isEnabled: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  hasMinSpendMessage: _propTypes.default.bool,
  onClickTnC: _propTypes.default.func,
  onClickItem: _propTypes.default.func,
  hasTnC: _propTypes.default.bool,
  locale: _propTypes.default.string,
  currencyCode: _propTypes.default.string
};
exports.DiscountData = DiscountData;
var _default = {
  PropTypes: DiscountData,
  DefultProps: {
    theme: _constant.DEFAULT_THEME,
    amount: 0,
    minSpend: 0,
    translations: {
      tnc: 'Terms and Condition',
      validFromUntil: 'Valid from {0} until {1}',
      validUntil: 'Valid until {0}',
      minSpendDesc: 'Minimum spend of {0} to use this promocode.'
    },
    isSelected: false,
    isEnabled: true,
    hasMinSpendMessage: false,
    hasTnC: false,
    currencyCode: 'MYR',
    locale: _constant2.DEFAULT_LOCALE,
    stackable: false,
    bigPointsAllowed: false,
    onClickTnC: function onClickTnC() {},
    onClickItem: function onClickItem() {}
  }
};
exports.default = _default;